<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
    <p style="font-size: 18px;">{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center; gap: 15px;padding-bottom: 25px;">
    <ng-container *ngFor="let btn of data.buttons">
        <button [ngClass]="btn.cssClass" (click)="close(btn.value)">
            {{ btn.text }}
        </button>
    </ng-container>
</mat-dialog-actions>